import { css, SerializedStyles } from "@emotion/react";
import { color } from "@/styles/theme";
import { CSSProperties } from "react";

type Prop = JSX.IntrinsicElements["div"] & {
  rightBorderDisplay?: boolean;
  externalStyleClass?: SerializedStyles;
  backgroundColor?: CSSProperties["backgroundColor"];
  flexDirection?: CSSProperties["flexDirection"];
};

export const SelectRowItemCell = (props: Prop) => {
  const {
    children,
    externalStyleClass,
    backgroundColor,
    rightBorderDisplay = false,
    flexDirection = "row",
    ...itemCellInnerContainrDivProps
  } = props;

  return (
    <div css={[itemCellContainer, { backgroundColor }, externalStyleClass]}>
      <div
        css={[
          itemCellInnerContainer,
          { flexDirection },
          rightBorderDisplay && borderRightStyle,
          {
            paddingTop: 8,
            paddingBottom: 8,
          },
        ]}
        {...itemCellInnerContainrDivProps}
      >
        {children}
      </div>
    </div>
  );
};

const itemCellContainer = css({
  height: "100%",
});

const itemCellInnerContainer = css({
  height: "100%",
  display: "flex",
  gap: 2,
  justifyContent: "center",
  alignItems: "center",
});

const borderRightStyle = css({
  borderRightWidth: 1,
  borderStyle: "solid",
  borderColor: color.iron,
});
